<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :loading-text="$t('newInvoices.loading')"
          :items-per-page="10"
          class="elevation-1 mb-3"
          item-key="id"
          :single-expand="true"
          show-expand
          :expanded.sync="expanded"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>
              {{ item.id }}
            </v-btn>
          </template>

          <template v-slot:item.date_due="{ item }">
            <span :class="item.expired ? 'red--text' : ''">
              {{ item.date_due }}
            </span>
          </template>

          <template v-slot:item.value_charge="{ item }">
            {{ getPortugueseMoney(item.value_charge) }}
          </template>

          <template v-slot:item.value_fees="{ item }">
            {{ getPortugueseMoney(item.value_fees) }}
          </template>

          <template v-slot:item.category="{ item }">
            {{ item.category }}
            <span class="caption grey--text">({{ item.value_unitary }})</span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              class="white--text"
              :color="item.expired ? 'red' : handleColorStatus(item.status)"
            >
              {{ item.expired ? $t("newInvoices.overdue") : item.statusUi }}
            </v-chip>
          </template>

          <!-- Buttons OPEN and CLOSE TD -->
          <template
            v-slot:item.data-table-expand="{ item, isExpanded, expand }"
          >
            <v-btn
              @click="[expand(true), getInvoice(item.id)]"
              v-if="!isExpanded"
              class="info"
              light
              small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              @click="[expand(false), (invoice = '')]"
              v-if="isExpanded"
              class="white"
              light
              small
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- // Buttons OPEN and CLOSE TD -->

          <!-- ############### -->
          <!-- INVOICE DETAILS -->
          <!-- ############### -->
          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length" class="pa-4">
              <div
                v-if="Object.keys(invoice).length === 0"
                class="text-center pa-10"
              >
                <v-progress-circular indeterminate></v-progress-circular>
              </div>
              <div v-else>
                <v-card>
                  <v-toolbar dense elevation="0">
                    <v-toolbar-title class="text-h5">
                      Fatura Nº {{ invoice.id }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn small class="info" @click="openInvoice(invoice)">
                      {{ $t("openInvoice") }}
                    </v-btn>

                    <v-btn
                      color="white"
                      class="ma-1 mr-2"
                      small
                      :light="
                        generatingPix
                          ? false
                          : invoice.status != 2 && invoice.status != 0
                      "
                      @click="showDialogPix(invoice)"
                      target="_black"
                      :disabled="
                        invoice.status == 0 ||
                          invoice.status == 2 ||
                          $store.state.feedbackProgress ||
                          generatingPix
                      "
                      :loading="$store.state.feedbackProgress || generatingPix"
                    >
                      <v-icon small left>
                        mdi-qrcode
                      </v-icon>
                      {{
                        invoice.can_generate_payment == "1"
                          ? $t("newInvoices.generatePix")
                          : $t("pay") + " Pix"
                      }}
                    </v-btn>
                  </v-toolbar>
                  <div class="pa-4">
                    <div class="overline pb-2 d-flex">
                      <div>{{ $t("payment") }}</div>
                      <v-spacer></v-spacer>
                      <div>
                        {{ $t("TOTAL") }}
                        {{ getPortugueseMoney(invoice.value_charge) }}
                      </div>
                    </div>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("title") }}
                            </th>
                            <th>
                              {{ $t("description") }}
                            </th>
                            <th>
                              {{ $t("amountTotal") }}
                            </th>
                            <th>
                              {{ $t("newInvoices.appliedValue") }}
                            </th>
                            <th>
                              {{ $t("newInvoices.invoiceValue") }}
                            </th>
                            <!-- <th>
                              {{ $t("pay") }}
                            </th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, i) in invoice.services" :key="i">
                            <td class="py-2">
                              {{ item.title }}
                            </td>
                            <td class="py-2">
                              {{ item.description }}
                            </td>
                            <td class="py-2 ">
                              {{ getPortugueseMoney(item.value_total) }}
                            </td>
                            <td class="py-2 ">
                              {{ item.value_applied }}
                            </td>
                            <td class="py-2 ">
                              {{ getPortugueseMoney(item.value) }}
                            </td>
                            <!-- <td class="py-2 text-right">
                              <template
                                v-if="
                                  !(
                                    item.date_pix == '0000-00-00 00:00:00' ||
                                    item.date_pix == null
                                  )
                                "
                              >
                                <template
                                  v-if="
                                    item.status == '1' &&
                                      item.date_current <= item.due_date &&
                                      item.date_current <= item.date_pix
                                  "
                                >
                                  <v-btn
                                    color="white"
                                    class="ma-1 mr-0"
                                    light
                                    small
                                    @click="showDialogPix(item)"
                                    target="_black"
                                    ><v-icon small left>mdi-qrcode</v-icon
                                    >Pix</v-btn
                                  >
                                  <v-btn
                                    v-if="item.barcode != ''"
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    @click="$copy(item.barcode)"
                                    ><v-icon left size="14"
                                      >mdi-content-copy</v-icon
                                    >{{ $t("code") }}</v-btn
                                  >
                                </template>

                                <template
                                  v-if="
                                    (item.date_current > item.date_pix ||
                                      item.date_current > item.due_date) &&
                                      item.status == '1'
                                  "
                                >
                                  <v-btn
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    :disabled="disabled"
                                    @click="newBillet(item.id, 'newBilletPix')"
                                    ><v-icon left size="14"
                                      >mdi-numeric-2-box-multiple-outline</v-icon
                                    >{{ $t("seccondCopy") }}</v-btn
                                  >
                                </template>
                              </template>
                              <template v-else>
                                <template
                                  v-if="
                                    item.status == '1' &&
                                      item.date_current <= item.due_date
                                  "
                                >
                                  <v-btn
                                    color="white"
                                    class="ma-1 mr-0"
                                    light
                                    small
                                    :href="item.link_billet"
                                    target="_black"
                                  >
                                    <v-icon left>mdi-barcode</v-icon>
                                    {{ $t("ticket") }}
                                  </v-btn>
                                  <v-btn
                                    v-if="item.barcode != ''"
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    @click="$copy(item.barcode)"
                                    ><v-icon left size="14"
                                      >mdi-content-copy</v-icon
                                    >{{ $t("code") }}</v-btn
                                  >
                                </template>
                                <template
                                  v-if="
                                    item.date_current > item.due_date &&
                                      item.status == '1'
                                  "
                                >
                                  <v-btn
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    :disabled="disabled"
                                    @click="newBillet(item.id, 'newBilletPix')"
                                    ><v-icon left size="14"
                                      >mdi-numeric-2-box-multiple-outline</v-icon
                                    >{{ $t("seccondCopy") }}</v-btn
                                  >
                                </template>
                              </template>
                            </td> -->
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </div>
            </td>
          </template>
          <!-- / INVOICE DETAILS -->
        </v-data-table>
        <DialogDepositPix />

        <NewInvoiceDetail
          v-if="invoiceDetail.dialog"
          :dialog="invoiceDetail.dialog"
          :invoice="invoiceDetail.data"
          @closeDialog="invoiceDetail.dialog = false"
        />
      </v-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
import DialogDepositPix from "@/components/common/financial/dialogDepositPix";
import NewInvoiceDetail from "./newInvoiceDetail";

export default {
  name: "views-backoffice-administrator-account-invoices",
  components: {
    DialogDepositPix,
    HeaderPrint,
    NewInvoiceDetail,
  },
  data: () => ({
    expanded: [],
    search: null,
    disabled: false,
    items: [],
    dateExpiration: "",
    invoice: "",
    charges: "",
    invoiceDetail: {
      dialog: false,
      data: {},
    },
    loading: false,
    generatingPix: false,
  }),
  async mounted() {
    this.listInvoices();
  },
  computed: {
    headers() {
      return [
        { text: "Nº", value: "id" },
        { text: this.$t("dueDate"), value: "date_due" },
        { text: this.$t("newInvoices.invoiceValue"), value: "value_charge" },
        // { text: "Valor Unitário", value: "value_unitary" },
        { text: this.$t("newInvoices.feeValue"), value: "value_fees" },
        { text: this.$t("status"), value: "status" },
        // { text: "Ações", value: "actions" },
        { text: this.$t("actions"), value: "data-table-expand" },
      ];
    },
    depositPix() {
      return this.$store.state.depositPix;
    },
  },
  watch: {
    depositPix(val) {
      if (val && !val.status) {
        this.listInvoices();
      }
    },
  },
  methods: {
    async showDialogPix(invoice) {
      if (invoice.can_generate_payment == "0") {
        this.$store.commit("dialogDepositPix", {
          status: true,
          value: invoice.value_charge,
          imgQrcode: invoice.link_ticket,
          codeQr: invoice.barcode,
          chargeId: invoice.id,
        });
      } else {
        this.generatingPix = true;

        try {
          const body = {
            id_charge: invoice.id,
          };

          const res = await this.$request.post(
            "administrator/charges/newValueCharge",
            body
          );

          if (res.length == 0) return;

          this.invoice.can_generate_payment = "0";

          const newValue = res.value_charge;
          const newFee = res.value_fees;
          const newDateDue = res.date_due;

          this.invoice.date_due = new Date(
            newDateDue.replace(" ", "T")
          ).toLocaleDateString();

          this.invoice.value_fees = newFee;
          this.invoice.value_charge = newValue;

          this.items = this.items.map((item) => {
            if (item.id == this.invoice.id) {
              return {
                ...item,
                value_fees: newFee,
                value_charge: newValue,
                date_due: this.invoice.date_due,
                expired: false,
              };
            }

            return item;
          });

          this.$store.commit("setFeedbackSnack", {
            msg: res.messages,
            color: "success",
          });

          const barcode = res.barcode;
          const link_ticket = res.dados;

          this.invoice.barcode = barcode;
          this.invoice.link_ticket = link_ticket;

          this.$store.commit("dialogDepositPix", {
            status: true,
            value: this.invoice.value_charge,
            imgQrcode: link_ticket,
            codeQr: barcode,
            chargeId: invoice.id,
          });
        } finally {
          this.generatingPix = false;
        }
      }
    },
    openInvoice(invoice) {
      this.invoiceDetail.dialog = true;
      this.invoiceDetail.data = invoice;
    },
    // Get List Invoices
    async listInvoices() {
      this.loading = true;

      this.items = [];

      const response = await this.$request.get("administrator/charges/list");
      if (response.length == 0) return;
      var data = response.dados.map((item) => {
        const now = new Date();
        const dateDue = new Date(item.date_due);

        let expired = false;
        if (now > dateDue && item.status == 1) {
          expired = true;
        }

        let can_generate_payment = item.can_generate_payment;
        if (item.date_pix) {
          const datePix = new Date(item.date_pix);
          const hourDiff =
            Math.abs(now.getTime() - datePix.getTime()) / 3600000;

          if (hourDiff >= 2 && item.status == 1) {
            can_generate_payment = "1";
            expired = true;
          }
        }

        return { ...item, expired, can_generate_payment };
      });
      // Handle data (important!):
      this.items = await Promise.all(
        this.handleDate(data),
        this.handleStatus(data)
      );

      this.loading = false;
    },

    // Handle 'date' (tratamento da data)
    handleDate(data) {
      return data.map(async (item) => {
        // Handle UI Range:
        // var dateStart = new Date(
        //   item.date_start.replace(" ", "T")
        // ).toLocaleDateString();
        // var dateEnd = new Date(
        //   item.date_end.replace(" ", "T")
        // ).toLocaleDateString();
        // var date_range_invoice = `${dateStart} - ${dateEnd}`;

        // Handle Date Expiration (Para mostrar o botão de 2ª via)
        // É necessário incrementear 8 dias na data de registro
        // para comparar com a data atual.
        // Se a data atual for maior que a data de expiração
        // mostrar o botão de segunda via, caso ele ainda
        // estiver com o status pendente ou 1.
        // var date_expiration = new Date(item.date_register);
        // date_expiration.setDate(date_expiration.getDate() + 8);
        // date_expiration = new Date(date_expiration).toLocaleString();

        // Object.assign(item, { date_range_invoice, date_expiration });

        item.date_due = new Date(
          item.date_due.replace(" ", "T")
        ).toLocaleDateString();

        return item;
      });
    },

    // Handle 'string' para alguns dados serem encontrados na busca.
    handleStatus(data) {
      return data.map((item) => {
        if (item.status == "1") {
          item.statusUi = this.$t("pending");
        } else if (item.status == "2") {
          item.statusUi = this.$t("paidLabel");
        } else {
          item.statusUi = this.$t("disabled");
        }
        return item;
      });
    },

    // Handle color v-chip status
    handleColorStatus(status) {
      const colorStatus = {
        5: "grey",
        2: "success",
        1: "orange",
      };
      return colorStatus[status];
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },

    // Segunda Via
    async newBillet(id_charge, endpoint) {
      this.disabled = true;
      const response = await this.$request.post(
        `administrator/account/${endpoint}`,
        {
          id_charge: id_charge,
        }
      );
      if (response.length == 0) {
        this.disabled = false;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("errorGeneratingDuplicate"),
          color: "error",
        });
        return;
      }
      this.disabled = false;
      await this.getInvoice(this.invoice.id);
      // const link = response.dados;
      // this.showDialogPix(link);
      // window.open(link, "_blank").focus;
    },

    // Open Invoice Details "Open TD"
    async getInvoice(id_invoice) {
      // Reset data
      this.invoice = {};

      var response = await this.$request.post(
        "administrator/charges/getCharge",
        {
          id_charge: id_invoice,
        }
      );

      if (response.length == 0) return;

      const chargeDetail = response.dados;

      chargeDetail.services = response.servicos;

      if (chargeDetail.status == "1") {
        chargeDetail.statusUi = "Pendente";
      } else if (chargeDetail.status == "2") {
        chargeDetail.statusUi = "Pago";
      } else {
        chargeDetail.statusUi = "Cancelado";
      }

      let subtotal = 0;
      let discounts = 0;

      chargeDetail.services.forEach((service) => {
        const totalValue = Number(service.value_total);
        const appliedValued = Number(service.value_applied);
        const minValue = Number(service.value_min);
        const value = Number(service.value);

        if (totalValue > value && service.type_billing === "porcentagem") {
          service.value_applied =
            value > minValue
              ? service.value_applied + "%"
              : this.$t("createNewEvent.form.min");
        } else if (service.type_billing === "multiplicacao") {
          service.value_applied =
            value > minValue
              ? service.value_applied + "x"
              : this.$t("createNewEvent.form.min");
        } else if (totalValue < value) {
          service.value_applied = this.$t("createNewEvent.form.min");
        } else if (appliedValued == totalValue) {
          service.value_applied = this.$t("fixed");
        }

        const number = Number(service.value);

        if (number > 0) {
          subtotal += number;
        } else {
          discounts += number;
        }
      });

      chargeDetail.operator = response.operator[0];
      chargeDetail.subtotal = subtotal;
      chargeDetail.discounts = discounts;
      this.invoice = chargeDetail;
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  filters: {
    formatDate: function(date) {
      return new Date(date).toLocaleDateString();
    },
    // decimalAdjustment: function (num) {
    //   return -(Math.round(-num + "e+2") + "e-2");
    // },
  },
};
</script>
<style scoped>
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
  min-height: 32px !important;
}
</style>
